import CmsFlexBox from './CmsFlexBox';
import CmsDescription from './CmsDescription';
import { ApiImageContainer } from '@ibe/api';

class CmsHotelData {
  descriptions?: Array<CmsDescription>;

  flexBoxes?: Array<CmsFlexBox>;

  displayCamperForm?: boolean;

  typeCode?: string;

  image: ApiImageContainer;

  distanceDescription?: string;

  title?: string;
}

export default CmsHotelData;
